import _ from "underscore";
import m from "mithril";
import {CellItem} from './cellItem'
import {ValidateResult} from '../contentType'
import {XmlTagInfo} from "../xmlTagProvider";
import {ScannerItemView} from "../../ui/items/ScannerItemView";

export class ScannerItem extends CellItem {
    private type: string;

    static fromXml(config: XmlTagInfo){
        return new ScannerItem(config);
    }

    constructor(config: XmlTagInfo) {
        super(config);
        this.type = config.attributes['type'];
    }

    getView() {
        // @ts-ignore
        return m(ScannerItemView.component, {cellItem: this});
    }

    getType() {
        return this.type;
    }

    set(value: string) {
        this.setVariable(value);
        this.form.reValidate();
    }

    validate() {
        const variable = this.getVariable();
        const valid = ! _.isUndefined(variable) && variable !== null;
        return valid ? ValidateResult.okResult() : ValidateResult.errorResult(this.questionary.messages.get("valuesCheckScanner"));
    }
}